<script setup>

import logger from "~/shared/utils/logger";

const props = defineProps({
  searchPath: {
    type: String,
    default: null
  },
  searchGuide: {
    type: String,
    default: null
  },
  foundData: {
    type: Object,
    default: null
  }
})

let guide = {
  content_type: ContentTypeEnum.Guide,
  chapters: []
}

if(props.foundData && Object.keys(props.foundData).length > 0 && props.foundData.content_type === ContentTypeEnum.Guide && props.foundData.chapters && Array.isArray(props.foundData.chapters)) {

  logger.log(`Guide:data provided: guide.title ${props.foundData.title}, guide.path: ${props.foundData.path}, chapters: ${props.foundData?.chapters.length > 0 ? props.foundData.chapters.length : "null"}`);

  guide = { ...props.foundData }
} else if (props.searchGuide && props.searchGuide.length > 0 && props.searchPath && props.searchPath.length > 0) {

  const queryName = props.searchPath.slice(1).replace(/\//g, "_") + `-guide_${props.searchGuide}`;

  logger.log(`Guide:query props name: ${queryName}, searchPath: ${props.searchPath}, searchGuide: ${props.searchGuide}`);


  const { data: guideChapters } = await useAsyncData(queryName, () => {
    const query = queryCollection('content')
      .where('path', 'LIKE', `${props.searchPath}%`)
      .where('guide', 'LIKE', `%${props.searchGuide}%`)

    if(import.meta.env.PROD) {
      query.where('published', '==', PublishedStatusEnum.Published)
    }

    return query.all()
  });

  const guides = guideChapters.value.filter(guide =>
    guide.content_type == "guide"
  )

  const foundGuide = guides.length > 0 ? guides[0] : null;

  if(guides.length > 1) {
    logger.warn(`Multiple guides found. This may indicate an issue with your content collection data. Check your content collection and ensure there is only one document with content_type: guide, guide: ${props.searchGuide}, and a path starting with ${props.searchPath}.`);

    for (const item of guides) {
      logger.warn(`guide: ${item.guide} ${item.content_type} chapter: ${item.title}, path: ${item.path}`);
    }
    logger.warn("More than one guide found");
    logger.log(`first guide found: ${foundGuide.title}, path: ${foundGuide.path}`);
  }

  foundGuide.chapters = guideChapters.value.filter(chapter =>
    chapter.content_type != ContentTypeEnum.Guide &&
    chapter.peer_order > 0
  ).sort((a, b) => (a.peer_order || 0) - (b.peer_order || 0)); // sort chapters by peer_order
  //

  logger.log(`Guide: query result filtered: chapters: ${foundGuide.chapters.length}`);

  guide = foundGuide ? { ...foundGuide} : guide;
    
} else {
  logger.warn("Guide component: No valid foundData or searchGuide prop provided. Rendering empty guide with no chapters.")
}

</script>

<template>
  <div v-if="guide && guide.chapters && guide.chapters.length > 0">
    <!-- <h2 class="text-xl font-bold mb-4">{{ guide.title }}</h2> -->
    <p class="mb-6">{{ guide.description }}</p>
    <div class="tiles-container not-prose">
      <TileButton
        v-for="(chapter, index) in guide.chapters"
        :key="chapter.path"
        :to="chapter.path"
        :image="chapter.image"
        :full="chapter.title"
        :short="chapter.tagline"
        :index="index"
      />
    </div>
  </div>
  <div v-else>
    <p>No guide found.</p>
  </div>
</template>

<style lang="css" scoped>

.tiles-container {
  @apply grid gap-4
         grid-cols-1
         sm:grid-cols-2
         md:grid-cols-3
         lg:grid-cols-4
         xl:grid-cols-5;
}

</style>